/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { useState } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { Alert } from '@mui/material';
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/background.png";
import tflogo from "assets/img/thermo.svg";
import axios from "axios";
import { useHistory } from "react-router-dom";

function Basic(props) {

  const resetURI = '/api/v1/apps/passwords/own/password'
  const [oldPassword, setOldPassword] = useState();
  const [newPassword, setNewPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();
  let historyObj = useHistory();
  const [error, setError] = useState();
  const [disableSubmit, setDisableSubmit] = useState(true);

  const pwd = localStorage.getItem("pwd");
  const pwdToken  = localStorage.getItem("pwdToken");
  const regex = new RegExp(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]).{8,}$/);

  if (pwd == null || pwd == 'undefined' || pwd == '') {
    historyObj.push("/");
  }

  const onTabCurrentPassword = (e) => {
    if(e.key === "Tab") {
      e.preventDefault();
      const passInput = document.getElementById('password');
      passInput.select();
    }
  }

  const onTabNewPassword = (e) => {
    if(e.key === "Tab") {
      e.preventDefault();
      const confirmPassInput = document.getElementById('confirmPassword');
      confirmPassInput.select();
    }
  }

  const handleConfirmPassword = (inputPass) => {
    if(newPassword && inputPass && newPassword.length > 0 && inputPass.length > 0 && newPassword === inputPass) {
      setDisableSubmit(false);
    }
  }

  const onKeyPress = (e) => {
    if(e.key === 'Enter') {
      handleSubmit();
    }
  };

  const handleSubmit = async () => {
    setError(null);
    const formData = new URLSearchParams();
    formData.append('default_password', oldPassword);
    formData.append('password', newPassword);
    formData.append('password_confirm', confirmPassword);

    if(validatePassword(oldPassword, newPassword, confirmPassword)) {
      try {
        axios.defaults.headers.common = {'Authorization': `Bearer ${pwdToken}`}
        const resetResponse = await axios.patch(
          resetURI,
          formData.toString(),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              "Accept": "application/json"
            }
          },
        );
        if (resetResponse.status == 200) {
          localStorage.removeItem("pwd");
          localStorage.removeItem("pwdToken");
          historyObj.push("/");
        }
      } catch (e) {
        localStorage.removeItem("pwdToken");
        if (e.response.status == 401) {
          setError("Bad credentials")
          return
        }
  
        if (e.response.status == 400) {
          setError("Bad Request");
          return
        }
      }
    }
    
  }
  
  const validatePassword = (oldPassword, newPassword, confirmPassword) => {
    if (pwd !== oldPassword) {
      setError("Current Password is not matching");
      setDisableSubmit(true);
      return false;
    } else if(!newPassword || newPassword.length < 1) {
      setError("New password required");
      setDisableSubmit(true);
      return false;
    } else if(!confirmPassword || confirmPassword.length < 1) {
      setError("Required confirm password.");
      setDisableSubmit(true);
      return false;
    } else if (!regex.test(newPassword)) {
      setError("Password complexity:\nMinimum of 8 characters containing uppercase letters, lowercase letters, numbers and special characters including spaces.");
      setDisableSubmit(true);
      return false;
    } else if (newPassword !== confirmPassword) {
      setError("Passwords do not match!");
      setDisableSubmit(true);
      return false;
    } else {
      setError("");
      setDisableSubmit(false);
      return true;
    }
  }

  const cancelSubmit = () => {
    localStorage.removeItem("pwd");
    historyObj.push("/");
  }

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          backgroundColor="#ECE8E7"
          borderRadius="lg"
          coloredShadow="dark"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          sx={{ background: "lightgrey" }}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Change Password
          </MDTypography>
          <Grid container spacing={3} justifyContent="center" sx={{ mt: 1, mb: 2 }}>
            <Grid item xs={6}>
              <div >
                <img src={tflogo} alt="logo" />
              </div>
            </Grid>
          </Grid>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form">
            <MDBox mb={2}>
              <MDBox sx={{ margin: "15px" }}>
                {error ? <Alert severity="error" sx={{ whiteSpace : 'pre-wrap'}} >{error}  </Alert> : ""}

              </MDBox>

            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="password"
                name="oldpass"
                id="oldpass"
                label="Enter current password"
                onChange={(e) => {
                  const input = e.target.value.trim();
                  if (input.length) {
                    setOldPassword(input);
                  }
                }}
                onKeyPress={onKeyPress}
                onKeyDown={onTabCurrentPassword}
                fullWidth
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="password"
                name="password"
                label="New password"
                id="password"
                onChange={(e) => {
                  const input = e.target.value.trim();
                  if (input.length) {
                    setNewPassword(input);
                  }
                }}
                onKeyPress={onKeyPress}
                onKeyDown={onTabNewPassword}
                fullWidth
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="password"
                name="confirmpass"
                label="Re-enter new password"
                id="confirmPassword"
                onChange={(e) => {
                  const input = e.target.value.trim();
                  if (input.length) {
                    setConfirmPassword(input);
                    handleConfirmPassword(input);
                  }
                }}
                onKeyPress={onKeyPress}
                fullWidth
              />
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton variant="gradient" disabled={disableSubmit} onClick={handleSubmit} color="dark" fullWidth>
                Change Password
              </MDButton>
            </MDBox>
            <MDBox mt={1} mb={1}>
              <MDButton variant="gradient" onClick={cancelSubmit} color="dark" fullWidth>
                Cancel
              </MDButton>

            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Basic;
